import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent, onUnmounted, ref, watch } from 'vue';
import UserExamHeader from './components/UserExamHeader.vue';
import UserExamBody from './components/UserExamBody.vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { CheatService } from '@/services/exam/cheat.service';
import { ExamService } from '@/services/exam/exam.service';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { CountdownService } from '@/services/exam/countdown.service';
import { QuestionService } from '@/services/exam/question.service';
import { PlayerManagerService } from '@/services/exam/playerManager.service';
import { useRoute, useRouter } from 'vue-router';
import CheatMask from './components/CheatMask.vue';
import { UserService } from '@/services/user.service';
import { MediaService } from '@/services/exam/media.service';
import { TOKEN_INVALID_ERRCODE } from '@/utils';
import Sentry from '@/utils/sentry';
export default defineComponent({
  name: 'Examination',
  components: {
    UserExamHeader: UserExamHeader,
    UserExamBody: UserExamBody,
    CheatMask: CheatMask
  },
  setup: function setup() {
    declareProviders([CountdownService, QuestionService, ExamService, CheatService, EnvCheckService, PlayerManagerService, MediaService]);
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var examService = useService(ExamService);
    var loading = ref(true);
    var hideCheatMask = route.query.hideMask;
    examService.setUserExamId(+route.params.id);

    if (route.params.answerId) {
      // 设置为查看答案模式
      // 禁止修改功能
      examService.setAnswerPaperId(+route.params.answerId);
      examService.setAnswerMode(true);
    }

    var goBack = function goBack() {
      router.replace({
        name: 'Home'
      });
    };

    var ideEventListener = function ideEventListener(event) {
      var eventData = event === null || event === void 0 ? void 0 : event.data;

      if (eventData) {
        if (eventData.eventType === 'networkError') {
          if (eventData.networkInfo && eventData.networkInfo.data) {
            if (eventData.networkInfo.data.errCode === TOKEN_INVALID_ERRCODE) {
              userService.logout();
            }
          }
        }
      }
    };

    var warnModal;
    watch(function () {
      return userService.user;
    }, function (user) {
      if (!(user && user.userId)) {
        warnModal = _Modal.warn({
          title: '提醒',
          content: '考试账号被异常登录，请勿向他人透露考试账号和密码，可能影响考试成绩',
          okText: '重新登录',
          onOk: goBack
        });
      } else {
        var _warnModal;

        (_warnModal = warnModal) === null || _warnModal === void 0 ? void 0 : _warnModal.destroy();
      }
    }); // 获取试卷信息

    examService.startExam().then(function () {
      if (!examService.destroyed) {
        Sentry.setContext('userInfo4Exam', examService.userInfo4Exam);

        if (!examService.answerMode) {
          window.addEventListener('message', ideEventListener, false);
        }
      }

      loading.value = false;
    }).catch(function (e) {
      Sentry.withScope(function (scope) {
        scope.setTag('api', 'startExam');
        scope.setLevel(Sentry.Severity.Error);
        Sentry.captureException(e);
      });
      router.push({
        name: 'UserItemList',
        query: route.query
      });
    });
    onUnmounted(function () {
      // 清除副作用
      examService.destroy();

      _Modal.destroyAll();

      window.removeEventListener('message', ideEventListener, false);
      Sentry.setContext('userInfo4Exam', null);
    });
    return {
      loading: loading,
      examService: examService,
      hideCheatMask: hideCheatMask
    };
  }
});